import { useRef, useState } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";

const MAX = 3;

export const KeyPhotos = ({ photos, onChange, w }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, MAX - photos.length);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    const added = [];
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const r = await api.post("/leads/photo", fd);
        if (r.data?.path) added.push(r.data.path);
      } catch (err) {
        toast.error(errMsg(err));
      }
    }
    onChange([...photos, ...added]);
    setBusy(false);
  };

  return (
    <div data-testid="wiz-key-photos" className="border border-dashed border-brand/60 bg-ink p-5">
      <div className="font-display text-base font-extrabold uppercase">{w.photoT}</div>
      <p className="mt-1 text-sm text-zinc-300">{w.photoB}</p>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        {photos.map((p, i) => (
          <div key={p} className="relative h-20 w-20 overflow-hidden border border-white/15">
            <img src={fileUrl(p)} alt={`${w.photoT} ${i + 1}`} data-testid={`wiz-key-photo-${i}`} className="h-full w-full object-cover" />
            <button type="button" data-testid={`wiz-key-photo-remove-${i}`} aria-label={w.photoRemove} onClick={() => onChange(photos.filter((x) => x !== p))} className="absolute right-0 top-0 grid h-6 w-6 place-items-center bg-ink/80 text-bone hover:text-brand"><X className="h-3.5 w-3.5" /></button>
          </div>
        ))}
        {photos.length < MAX && (
          <button type="button" data-testid="wiz-key-photo-button" disabled={busy} onClick={() => input.current?.click()} className="inline-flex items-center gap-2 bg-brand px-5 py-3 font-display text-sm font-extrabold uppercase text-cream transition-transform duration-300 hover:-translate-y-0.5 disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Camera className="h-4 w-4" />} {busy ? w.photoSending : w.photoBtn}
          </button>
        )}
      </div>
      <input ref={input} type="file" accept="image/*" multiple hidden data-testid="wiz-key-photo-input" onChange={upload} />
    </div>
  );
};
